var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 12C20.0367 12 16 16.0792 16 21.0915C16 26.9188 23.68 36.3848 24.007 36.7839L25 38L25.993 36.7839C26.32 36.3835 34 26.9188 34 21.0915C34 16.0779 29.9633 12 25 12ZM25 14.5997C28.5435 14.5997 31.4257 17.5129 31.4257 21.0915C31.4257 24.6077 27.4173 30.655 25 33.8592C22.5827 30.6576 18.5743 24.6129 18.5743 21.0915C18.5743 17.5129 21.4565 14.5997 25 14.5997ZM25 17.8367C23.2224 17.8367 21.7821 19.2913 21.7821 21.0864C21.7821 22.8815 23.2224 24.3361 25 24.3361C26.7776 24.3361 28.2179 22.8815 28.2179 21.0864C28.2179 19.2913 26.7776 17.8367 25 17.8367Z",
    fill: "#0074B8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    stroke: "#0074B8",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.46ae925f8e14e1687a0d92f859436aa2.svg";
export { ForwardRef as ReactComponent };